import { render, staticRenderFns } from "./ModalDetalleEdicion.vue?vue&type=template&id=4037c067"
import script from "./ModalDetalleEdicion.vue?vue&type=script&lang=js"
export * from "./ModalDetalleEdicion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports